import { Banner } from '@ghq-abi/design-system-v2';
import { useTranslate } from '@tolgee/react';

import { ETolgeeNamespaces } from '~/shared/enums/ETolgeeNamespaces';

export function WelcomeBanner() {
  const { t } = useTranslate(ETolgeeNamespaces.HOME);

  return (
    <Banner.Root variant="default" className="rounded-md">
      <Banner.Content fontVariant="light">
        <Banner.Subtitle className="text-primary">
          {t('home.banner.subtitle')}
        </Banner.Subtitle>
        <Banner.Title>{t('home.banner.title')}</Banner.Title>
      </Banner.Content>
    </Banner.Root>
  );
}
